import { cloudflareWorkerReverseProxy } from '@/core/lib/cloudflare-worker-reverse-proxy';
import { ILinkPreviewResponse } from '@linkie/domain';

const getReferrer = async () => {
  const source = document.referrer;
  if (!source) return 'Direct';

  try {
    const linkPreview: ILinkPreviewResponse = await cloudflareWorkerReverseProxy.post(`/link-preview`, {
      url: source,
    });

    return linkPreview?.provider_display ?? 'Direct';
  } catch (error) {
    console.error('Failed to fetch link preview:', error);
    return 'Direct';
  }
};

export default getReferrer;
